import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { IPartnerLnRStatusesView } from 'clickNgo/models/crud/views'
import { Nullable } from 'cng-common/models/utils'
import { CrudStore } from 'core/types/crudStore'
import Logger from 'core/utils/Logger'

import { IPartnerLnRStatus } from '../models/reportDetails'

import { mapPartnerLnRStatusFromView } from './mapping/mapPartnerLnRStatusFromView'

export async function fetchPartnerLnRStatus(
  partnerId: string,
  options?: ICrudFetchOptions
): Promise<Nullable<IPartnerLnRStatus>> {
  const source = CrudStore.get<IPartnerLnRStatusesView>(
    CrudStoreItem.PartnerLnRStatuses,
    options?.cacheKey || partnerId
  )

  return source
    .getById({ id: partnerId, force: options?.isForce, keyField: 'PartnerId' })
    .then((response) => {
      if (response) {
        return mapPartnerLnRStatusFromView(response)
      }

      return null
    })
    .catch((err) => {
      Logger.error(err)
      return null
    })
}
